export default {
    refurbish_device_title: "Refurbish Device",
    refurbish_device_command_sent_to_the_device: "Device Refurbished",
    refurbish_device_error_sending_the_command: "Error trying to refurbish the device",
    refurbish_device_label: "This process will mark the actual device as refurbished, freeing the device's registration data so that it can be used again from the device import.",
    refurbish_device_refurbish: "Refurbish",
    refurbish_device_esn: "ESN",
    refurbish_device_imei: "IMEI",
    refurbish_device_sim_provider_account:"SIM Provider Account",
    refurbish_device_sim_number: "SIM #",
    refurbish_device_phone_number: "Phone #"


}